import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';
import SideDrawer from 'components/SideDrawer/SideDrawer';
import AppBar from 'components/AppBar/AppBar';
import AppFooter from 'components/AppFooter/AppFooter';
import ProgressBar from 'react-toolbox/lib/progress_bar';

import { Layout, NavDrawer, Panel } from 'react-toolbox/lib/layout';

function App(props) {
  const {view, layout} = props;
  const title = "Lakrito";

  const renderRoute = () => {
    // console.log('rendering...', view.currentRoute);
    if (view.loggingIn) return <ProgressBar type="circular" mode="indeterminate" />;
    if (view.currentRoute) return view.currentRoute.main(view.currentRoute.extra);
    return null;
  };

  return (
    <Layout>
      <NavDrawer
        theme={styles}
        active={layout.sideBarOpen}
        pinned={layout.sideBarDocked}
        onOverlayClick={layout.toggleSideBarOpen}
        premanentAt="lg"
      >
        <SideDrawer title={title} />
      </NavDrawer>
      <Panel className={styles.content}>
        <AppBar
          title={title}
          toggleSidebar={layout.toggleSideBarOpen}
        />
        <section>
          {renderRoute()}
        </section>
        <AppFooter />
      </Panel>
    </Layout>
  );
}

export default inject('view', 'layout')(observer(App));



// WEBPACK FOOTER //
// ./src/views/App/App.js